const links = {
  "links.CLI_repository": "https://cli.nestle.platform.sh",
  "links.blackfire.connect": "https://blackfire.io/session/connect/nestle"
};

export default links;
